export enum ParentPermissionEnum {
    CompanySetup = "CompanySetup",
    chart = "chart",
    clinician = "clinician",
    documentAddendum = "documentAddendum",
    inquiries = "inquiries",
    referrals = "referrals",
    scheduler = "scheduler",
    documents = "documents",
    employeeInformation = "employeeInformation",
    MessageCenter = "messageCenter",
    simitree = "simitree",
    nonPatientActivity = "nonPatientActivity",
    taskNotes = "taskNotes",
    // family portal pernmission enums
    familyPortalBilling = "familyPortal.billing",
    familyPortalClinical = "familyPortal.clinical",
    familyPortalScheduling = "familyPortal.scheduling",
    familyPortalOthers = "familyPortal.others"
}
